<template>
  <div>
    <base-header class="pb-6"> </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mt-4 mb-4 title-2 bold">Rutas</h3>
            </div>
            <div class="col-6">
              <h3
                class="mt-4 mb-4 link-discount text-right"
                @click.prevent="showModal"
              >
                Ver cuadro de descuentos
              </h3>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="mb-4">
                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="dates.config"
                      class="form-control datepicker"
                      @input="dateRangeChange"
                      placeholder="Seleccione fecha"
                      v-model="dates.range"
                    >
                    </flat-picker>
                  </base-input>
                </div>
                <div class="d-inline-block pl-2 ml-3 mr-3 text-route">
                  Rutas Totales
                  <span v-if="dates.range">({{ dates.range }})</span>:
                  {{ totalRoutes }} rutas
                </div>
                <div class="d-inline-block ml-2 mr-2 text-route">
                  <strong>|</strong>
                </div>
                <div class="d-inline-block pl-2 mr-3 text-route">
                  Rutas Tarde: {{ totalTardies }} rutas
                </div>
                <div class="d-inline-block ml-2 mr-2 text-route">
                  <strong>|</strong>
                </div>
                <div class="d-inline-block pl-2 text-route">
                  % Rutas Tarde: {{ percentageTardies }}%
                </div>
              </div>
            </div>

            <el-table
              class="table-responsive desing"
              header-row-class-name="thead-desing"
              row-key="id"
              :data="queriedData"
              row-class-name=""
            >
              <el-table-column label="Fecha" prop="date" min-width="100px">
                <template v-slot="{ row }">{{ row.date }}</template>
              </el-table-column>
              <el-table-column
                label="Ruta (Codigo)"
                prop="name"
                min-width="139px"
              >
                <template v-slot="{ row }"
                  ><strong>{{ row.name }}</strong></template
                >
              </el-table-column>

              <el-table-column label="Tipo" prop="type" min-width="90px">
                <template v-slot="{ row }"
                  ><strong :class="{ penalty: row.type === 'Extra' }">{{
                    row.type
                  }}</strong></template
                >
              </el-table-column>

              <el-table-column
                label="Hora programada"
                prop="scheduledTime"
                min-width="169px"
              >
                <template v-slot="{ row }">{{ row.scheduledTime }}</template>
              </el-table-column>

              <el-table-column
                label="Hora de entrega"
                prop="deliveredTime"
                min-width="159px"
              >
                <template v-slot="{ row }">{{ row.deliveredTime }}</template>
              </el-table-column>

              <el-table-column
                label="Tardanza (min)"
                prop="totalTimeTardie"
                min-width="100px"
              >
                <template v-slot="{ row }">{{ row.totalTimeTardie }}</template>
              </el-table-column>

              <el-table-column label="Status" prop="status" min-width="110px">
                <template v-slot="{ row }">
                  <strong
                    class="tag-level-desing"
                    :class="{
                      red: row.status === 'Tarde',
                      green: row.status === 'A tiempo'
                    }"
                    >{{ row.status }}</strong
                  ></template
                >
              </el-table-column>

              <el-table-column
                label="Penalidad"
                prop="penaltyAmount"
                min-width="120px"
              >
                <template v-slot="{ row }"
                  ><strong class="penalty"
                    >{{ row.currency }} {{ row.penaltyAmount }}</strong
                  ></template
                >
              </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-4"
            >
              <div class="">
                <p class="card-category">
                  Mostrando {{ from }} to {{ to }} de {{ total }} registros
                </p>
              </div>
              <base-pagination
                class="pagination-no-border mt-4"
                @input="next"
                v-model="pagination.page"
                :per-page="pagination.rowsPerPage"
                v-if="pagination.totalItems > 10"
                :total="total"
              >
              </base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Routes-->
    <CustomModal
      :is-modal="showDiscount"
      @closeModal="showDiscount = false"
      :closeOuth="true"
    >
      <h5 class="modal-title text semi-bold">Cuadro de descuentos:</h5>
      <div class="">
        <div class="mt-4 mb-4 p-4">
          <el-table
            :data="priceDiscount"
            row-key="id"
            header-row-class-name="thead-desing-dark"
            v-if="priceDiscount.length !== 0"
            class="desing-dark"
          >
            <el-table-column label="Items" prop="label" min-width="200px">
              <template v-slot="{ row }">{{ row.label }}</template>
            </el-table-column>

            <el-table-column label="Monto" prop="amount" min-width="116px">
              <template v-slot="{ row }"
                ><strong>{{ row.currency }} {{ row.amount }}</strong></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip
} from "element-ui";
import { mapActions, mapState, mapMutations } from "vuex";
import { VueContentLoading } from "vue-content-loading";
import tardanzaPaginationMixin from "../../mixin/tardanzaPagination Mixin";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es";
import CustomModal from "../../components/CustomModal";
export default {
  name: "ListTardanzas",
  mixins: [tardanzaPaginationMixin],
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    VueContentLoading,
    flatPicker,
    CustomModal
  },
  data() {
    return {
      showDiscount: false,
      tableData: [],
      pageActual: 1,
      currentPage: 1,
      dates: {
        range: "",
        config: { allowInput: false, mode: "range", locale: Spanish }
      },
      rangeDate: []
    };
  },
  computed: {
    ...mapState("tardanza", [
      "tardanzas",
      "pagination",
      "totalRoutes",
      "totalTardies",
      "percentageTardies",
      "priceDiscount"
    ])
  },
  methods: {
    ...mapActions("tardanza", ["GET_TARDANZAS", "GET_PRICE_DISCOUNT"]),
    ...mapMutations("tardanza", ["SET_TARDANZAS", "SET_PAGINATION"]),
    showModal() {
      this.showDiscount = true;
    },
    dateRangeChange(val) {
      const dates = val.split("a").map(item => {
        return item.trim();
      });
      dates.length === 2 ? (this.rangeDate = dates) : "";
    },
    next(page) {
      this.pageActual = page;
      this.SET_TARDANZAS([]);
      this.SET_PAGINATION({});
      const initDdate = this.rangeDate.length >= 1 ? this.rangeDate[0] : null; //init_date
      const endDate = this.rangeDate.length >= 2 ? this.rangeDate[1] : null; // end_date
      const days = this.rangeDate;
      this.GET_TARDANZAS({
        page,
        /* days, */
        init_date: initDdate,
        end_date: endDate,
        type: days.length ? "count" : ""
      }).then(() => {
        this.pageActual = this.pagination.page;
      });
    }
  },
  watch: {
    rangeDate(days) {
      console.log("days->", days);
      const initDdate = days && days.length >= 1 ? days[0] : null; //init_date
      const endDate = days && days.length >= 2 ? days[1] : null; // end_date
      console.log(initDdate, endDate);
      this.SET_TARDANZAS([]);
      this.SET_PAGINATION({});
      this.GET_TARDANZAS({
        page: 1,
        /* days, */
        init_date: initDdate,
        end_date: endDate,
        type: "count"
      }).then(() => {
        this.pageActual = this.pagination.page;
      });
    }
  }
};
</script>

<style scoped></style>
